import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import ArticleIcon from '@mui/icons-material/Article';
import Grid from '@mui/material/Grid';
import { useQuery } from '../hooks/useQuery';
import { useAuth } from '../hooks/useAuth';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate, useSearchParams } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useTheme } from '@mui/material/styles';
import ItemContrato from '../components/ItemContrato';
import ItemPedido from '../components/ItemPedido';
import AlertaProtocoloVencido from '../components/AlertaProtocoloVencido';
import OutlinedInput from '@mui/material/OutlinedInput';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { isCnpj, serializeQueryString } from '../utils';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { Button } from '@mui/material';
import { useSnackbar } from '../hooks/useSnackbar';

let debounce = null;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const ExportarNotasPage = () => {
  const { getExcelData, listarComboFornecedor } = useQuery();
  const { user, isUsuarioSebrae, logout } = useAuth();
  const [loading, setLoading] = React.useState(false);
  let [searchParams, setSearchParams] = useSearchParams();
  const [queryParams, setQueryParams] = React.useState({
    busca: '',
  });
  const [cnpjs, setCnpjs] = React.useState([]);
  const [fornecedores, setFornecedores] = React.useState([]);
  const navigate = useNavigate();
  const theme = useTheme();
  const snackbar = useSnackbar();

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setCnpjs(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const exportarExcel = async (filename) => {
    if (cnpjs.length == 0) {
      snackbar.showSnackbar('Selecione um fornecedor.');
      return;
    }

    let selCnpjs = [];
    cnpjs.map((res) => {
      selCnpjs.push(res.cnpj);
    });
    const result = await getExcelData({ fornecedores: selCnpjs });

    const worksheet = XLSX.utils.json_to_sheet(result.data.data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Notas');
    XLSX.writeFile(workbook, 'Relatorio.xlsx');
  };

  const getFornecedores = async () => {
    setLoading(true);
    const result = await listarComboFornecedor();
    if (result && result.data && result.data.data) {
      const arr = result.data.data.map((item) => ({
        ...item,
      }));

      setFornecedores(arr);
    }
    setLoading(false);
  };

  React.useEffect(() => {
    getFornecedores();
  }, []);

  return (
    <Box
      mt={8}
      sx={{ width: '100%', background: '#FAFCFF', minHeight: '100vh' }}
    >
      <AppBar position="static" color="primary" style={{ padding: 10 }}>
        <Grid container spacing={0}>
          <Grid item display="flex" alignItems="center">
            <ArticleIcon
              sx={{
                fontSize: 40,
              }}
            />
            <span style={{ color: 'white', fontSize: 20 }}>
              Relatório de Notas Fiscais
            </span>
          </Grid>
        </Grid>
      </AppBar>

      <AlertaProtocoloVencido />

      <Box paddingX={4}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <p style={{ color: '#0e72b8', fontWeight: 'bold' }}>
              Pesquisar fornecedor
            </p>
            {/* <FormControl sx={{ m: 1, width: '100%' }}> */}

            <Autocomplete
              multiple
              id="tags-standard"
              style={{ height: 40 }}
              options={fornecedores}
              getOptionLabel={(option) => option.razao_social}
              onChange={(event, newValue) => {
                console.log(newValue);
                setCnpjs(newValue);
              }}
              // defaultValue={[top100Films[13]]}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  style={{ minHeight: '40px !important' }}
                  placeholder="Listar fornecedores"
                />
              )}
            />
            {/* <Select
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                multiple
                value={cnpjs}
                onChange={handleChange}
                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {fornecedores.map((fornecedor) => (
                  <MenuItem
                    key={fornecedor.cnpj}
                    value={fornecedor.cnpj}
                  // style={getStyles(name, personName, theme)}
                  >
                    {fornecedor.razao_social}
                  </MenuItem>
                ))}
              </Select> */}
            {/* </FormControl> */}
          </Grid>
          <Grid item xs={8}></Grid>
          <Grid item xs={4}>
            <Button
              variant="contained"
              onClick={() => exportarExcel('relatorio')}
              style={{ width: '100%', marginTop: 10 }}
            >
              Exportar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
